import(/* webpackMode: "eager" */ "/home/interim/frontend/app/certificates/page.tsx");
